var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('ChipList',{attrs:{"item":{items: _vm.items_chips}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }